module.exports = __webpack_public_path__ + "static/img/001.fab6ce0d.jpg";